export const formatDate = (date: Date): string => {
    return date.toLocaleDateString('it-IT', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

export const getStatusColor = (status: string) => {
    switch (status) {
        case 'pending': return '#ffc107';
        case 'in-progress': return '#17a2b8';
        case 'obtained': return '#6f42c1';
        case 'digitized': return '#28a745';
        default: return '#000000';
    }
};

export const getStatusText = (status: string) => {
    switch (status) {
        case 'pending': return 'In Attesa';
        case 'in-progress': return 'In Corso';
        case 'obtained': return 'Ottenuto';
        case 'digitized': return 'Digitalizzato';
        default: return status;
    }
};

// Tooltip descriptions for status
export const getStatusTooltip = (status: string): string => {
    switch (status) {
        case 'pending':
            return 'Opera identificata ma non ancora contattata per i permessi';
        case 'in-progress':
            return 'Trattative in corso per ottenere i permessi di utilizzo';
        case 'obtained':
            return 'Permessi ottenuti - Opera pronta per essere digitalizzata';
        default:
            return '';
    }
};

// Tooltip description for digitization
export const getDigitizationTooltip = (isDigitized: boolean): string => {
    if (isDigitized) {
        return 'Opera già fotografata e digitalizzata';
    }
    return 'Opera non ancora fotografata - richiede digitalizzazione';
};

// Combined status explanation
export const getStatusExplanation = (): string => {
    return 'Pending: Opera identificata • In Progress: Trattative permessi • Obtained: Permessi ottenuti';
};

// Digitization vs Status explanation
export const getDigitizationExplanation = (): string => {
    return 'Digitalizzazione e Status sono indipendenti: puoi avere permessi (Obtained) ma non ancora fotografato, o viceversa.';
};

export const handleError = (error: any): string => {
    return error.message || 'Si è verificato un errore.';
};

export const isDigitized = (artwork: any): boolean => {
    return artwork.isDigitized === true;
};

export const getOperationTypeText = (type: string | undefined): string => {
    if (!type) {
        return "Unknown Operation";
    }

    return type
        .replace(/-/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
};
